import DefaultRenderer from './Default'
import store from '../../store'
import { qs, qsa, kNumberFormater } from '../../utils'
//import axios from 'axios';
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'

class AboutRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    // store.resizeFn = this.onResize.bind(this);
    // qs('.disclaimer') && qs('.disclaimer').classList.remove('hide');
    store.resizeFn = null
    store.section = 'terms'

    this.setHeaderStyle('white')
    this.onPageChange()

    //this.setUpMap();
    this.initSlide()
    this.setUpVideo()
  }

  onEnter() {
    super.onEnter()
    // qs(".disclaimer").classList.remove("hide");
    // qs(".disclaimer").classList.add("about");
  }

  onLeave() {
    super.onLeave()
    // qs(".disclaimer").classList.add("hide");
    // qs(".disclaimer").classList.remove("about");
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  setUpMap() {
    const defaultRadiusMultiplier = 6
    try {
      axios
        .get('https://d3jlszua3q4cyr.cloudfront.net/content/web/opens-by-state.csv')
        .then((response) => {
          const arr = response.data.split('\n')
          const total = arr.filter((c) => c).reduce((t, c) => t + parseFloat(c.split(',')[0]), 0)
          arr.map((c, i) => {
            const [qty, id] = c.split(',')
            const $g = qs(`#US-${id}`)
            const $gHover = qs(`#US-${id}-hover`)
            if (id && $g && $gHover) {
              const $text = qs('text', $g)
              const $hidden = qs('.visually-hidden', $g)
              const $circle = qs('circle', $g)
              const percentage = (qty * 100) / total
              const textNumber = kNumberFormater(qty)

              if ($text && $circle) {
                $circle.setAttribute('r', defaultRadiusMultiplier * percentage)
                if (percentage > 10) {
                  $circle.style.fill = 'rgba(0, 0, 0, 0.6)'
                } else if (percentage > 7) {
                  $circle.style.fill = 'rgba(68, 43, 120, 0.85)'
                }

                let minRadius = 30
                if (i < 5) {
                  $g.classList.add('featured')
                }
                if (textNumber.length >= 5) {
                  minRadius = 45
                }

                const r = parseFloat($circle.getAttribute('r'))
                $gHover.addEventListener('mouseover', () => {
                  $circle.setAttribute('r', `${r < minRadius ? minRadius : r * 1.1}`)
                  $text.style.fill = 'rgba(256,256,256,1)'
                  $text.style.transitionDelay = '.1s'
                })
                $gHover.addEventListener('mouseleave', () => {
                  $circle.setAttribute('r', `${r}`)
                  $text.style.fill = 'rgba(256,256,256,0)'
                  $text.style.transitionDelay = '0s'
                })
                $gHover.addEventListener('focusout', () => {
                  $circle.setAttribute('r', `${r}`)
                  $circle.style.stroke = 'transparent'
                  $circle.style.strokeWidth = '0'
                  $text.style.fill = 'rgba(256,256,256,0)'
                  $text.style.transitionDelay = '0s'
                })
                $gHover.addEventListener('focus', () => {
                  $circle.setAttribute('r', `${r < minRadius ? minRadius : r * 1.1}`)
                  $circle.style.stroke = 'var(--magenta)'
                  $circle.style.strokeWidth = '3'
                  $text.style.fill = 'rgba(256,256,256,1)'
                  $text.style.transitionDelay = '.1s'
                })
                const amount = textNumber.includes('k') ? textNumber.replace('k', '') : textNumber
                $text.textContent = `${textNumber}`
                $hidden.textContent = `${amount} ${
                  textNumber.includes('k') ? 'thousands' : ''
                } App openings in ${states[id]} state`
              }
            }
          })
        })
    } catch (error) {
      console.log(error)
    }
  }

  initSlide() {
    const videoSlide = new Swiper('.video-slide ', {
      slidesPerView: 1,
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      on: {
        paginationRender: function (swiper, el) {
          el.querySelectorAll('.swiper-pagination-bullet').forEach(function (child) {
            child.setAttribute(
              'aria-label',
              child.getAttribute('aria-label').replace('total', swiper.pagination.bullets.length),
            )
          })
        },
      },
      pagination: {
        el: '.video-slide-dots',
        clickable: true,
        renderBullet: function (index, className) {
          const ariaLabel = `go to video ${index + 1} out of total`
          return '<button class="' + className + '" aria-label="' + ariaLabel + '"></button>'
        },
      },
    })
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')

    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)
      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $trigger.click()
        }
      })
    })
  }
}

export default AboutRenderer
